import _jsx from "@babel/runtime/helpers/jsx";
var _Glyphicon, _Text;
import React from 'react';
import { Glyphicon, Text } from 'reaxl';
import { sendClick } from 'reaxl-analytics';
function Header(_ref) {
  let {
    atcFordLogo,
    fordLogo
  } = _ref;
  const renderImage = (image, alt) => image && image.src && /*#__PURE__*/React.createElement("img", Object.assign({
    key: "logoImage"
  }, image, {
    alt: image.alt || alt
  }));
  return /*#__PURE__*/_jsx("header", {
    className: "fordHeader navbar navbar-default",
    "data-cmp": "header"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "container header-info-bar"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "navbar-wrapper justify-content-between"
  }, void 0, /*#__PURE__*/_jsx("a", {
    href: "//ford.com/used",
    className: "header-ford display-flex text-blue-darkest",
    "aria-label": "More Program Details",
    onClick: event => sendClick('backToResultsClick', event, {})
  }, void 0, _Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
    glyph: "chevron-left",
    className: "text-size-400"
  })), _Text || (_Text = /*#__PURE__*/_jsx(Text, {
    className: "title-link margin-left-2",
    size: 200,
    weight: "bold"
  }, void 0, "More Program Details"))), /*#__PURE__*/_jsx(Text, {
    componentClass: "em",
    size: 200,
    color: "blue-darkest",
    className: "title-text display-flex align-items-center gap-1"
  }, void 0, "Powered by", renderImage(atcFordLogo, 'Autotrader')))), /*#__PURE__*/_jsx("div", {
    className: "header-logo padding-2 bg-accent display-flex align-items-center justify-content-center"
  }, void 0, /*#__PURE__*/_jsx("a", {
    href: "/cars-for-sale"
  }, void 0, renderImage(fordLogo, 'Ford Blue Advantage'))));
}
export default Header;